import {AuthenticationService} from './authentication.service';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {User} from '../_model/user';
import {map} from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `${currentUser.token}`
        }
      });
    }

    // handle response
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event.hasOwnProperty('body')) {
        this.modifyBody((event as any).body);
      }
      return event;
    }, (error: any) => {
      if (error.hasOwnProperty('error')) {
        const err = error.error;
        if (err.hasOwnProperty('refreshToken')) {
          this.modifyBody(err);
        }
      }
    }));
  }

  private modifyBody(body: any) {
    if (body.refreshToken) {
     const currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
     const modifiedCurrentUser = currentUser as User;
     modifiedCurrentUser.token = body.refreshToken;
     localStorage.setItem('currentUser', JSON.stringify(modifiedCurrentUser));
     this.authenticationService.currentUserSubject.next(modifiedCurrentUser);
    }
  }
}
